// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"7f21ec12","223":"2f0032ee","239":"c444bd6d","450":"5a06079e","455":"994f1c02","520":"f4b49ffe","670":"cbf1d600"}[chunkId] + ".chunk.js";
};